import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { ISubscriptionState } from './types';

const initialState: ISubscriptionState = {
  plans: { loading: false, data: [], count: 0, error: null },
  currentPlan: { loading: false, data: null, error: null },
  subscribedOrgs: { loading: false, data: [], count: 0, error: null },
  counts: { loading: false, data: { total_plans: 0, active_plans: 0, active_subscriptions: 0 }, error: null },
};

const selectSubscriptionState = (state: RootState) => state.subscription || initialState;

export const selectSubscriptionPlans = createSelector(
  selectSubscriptionState,
  (state) => state.plans.data
);

export const selectSubscriptionPlansLoading = createSelector(
  selectSubscriptionState,
  (state) => state.plans.loading
);

export const selectSubscriptionPlansCount = createSelector(
  selectSubscriptionState,
  (state) => state.plans.count
);

export const selectCurrentPlan = createSelector(
  selectSubscriptionState,
  (state) => state.currentPlan.data
);

export const selectCurrentPlanLoading = createSelector(
  selectSubscriptionState,
  (state) => state.currentPlan.loading
);

export const selectSubscribedOrgs = createSelector(
  selectSubscriptionState,
  (state) => state.subscribedOrgs.data
);

export const selectSubscribedOrgsCount = createSelector(
  selectSubscriptionState,
  (state) => state.subscribedOrgs.count
);

export const selectSubscribedOrgsLoading = createSelector(
  selectSubscriptionState,
  (state) => state.subscribedOrgs.loading
);

export const selectSubscriptionCounts = createSelector(
  selectSubscriptionState,
  (state) => state.counts.data
);

export const selectSubscriptionCountsLoading = createSelector(
  selectSubscriptionState,
  (state) => state.counts.loading
);
